import React, { useEffect, useState } from "react";
import { Input } from "../../ui/Input";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";

export const PensionFundForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    // useEffect(()=>{
    //     if (formData.uboIsPensionFundRegistered === "Yes") {
    //         setModalMessage(
    //             <>
    //               You will need to directly enquire with the relevant party for this information; there is not a public register of funds regulated by the Pensions Regulator.
    //             </>
    //           );
    //         setIsModalOpen(true);
    //     }
        
    // }, [formData, onChange]);

    return (
        <>
            <Input
                label={"Pension Fund Name"}
                name={"uboPensionFundName"}
                value={formData.uboPensionFundName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input
                label={"Registered Address"}
                name={"uboRegisteredAddress"}
                value={formData.uboRegisteredAddress}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <RadioGroup
                label={"Is the Pension Fund registered with the Pensions Regulator?"}
                name={"uboIsPensionFundRegistered"}
                value={formData.uboIsPensionFundRegistered}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
                required
            />

            <RadioGroup
                label={"Is the Pension Fund registered with HMRC?"}
                name={"uboIsPensionFundRegisteredWithHMRC"}
                value={formData.uboIsPensionFundRegisteredWithHMRC}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
            />

            <Input
                label={"Regulatory Reference Number"}
                name={"uboRegulatoryReferenceNumber"}
                value={formData.uboRegulatoryReferenceNumber}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />
            {isModalOpen && (
        <div
          className="modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1,
          }}
        >
          <div
            className="modal-content"
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
            <p style={{ textAlign: "left" }}>{modalMessage}</p>
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                border: "none",
                background: "#07b1b0",
                color: "white",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
        </>
    );
})